import { render, staticRenderFns } from "./AudioBlock.vue?vue&type=template&id=019a178e&scoped=true&"
import script from "./AudioBlock.vue?vue&type=script&lang=js&"
export * from "./AudioBlock.vue?vue&type=script&lang=js&"
import style0 from "./AudioBlock.vue?vue&type=style&index=0&id=019a178e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a178e",
  null
  
)

export default component.exports